// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RestaurantSpecialOffer_wrapper__lYSxS"};